import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414L11 3.414 9.914 4.5l1.293 1.293a1 1 0 0 1-1.414 1.414L8.5 5.914 7.446 6.968a4 4 0 1 1-1.414-1.414l1.757-1.757.004-.004.004-.004zM2 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceLoginKey = { render };
export {
  interfaceLoginKey as default,
  render
};
//# sourceMappingURL=interface-login-key.svg.js.map
